import LazyLoadListWrapper from './LazyLoadListWrapper';

export default LazyLoadListWrapper;
